import { nextTick as c } from "vue";
const s = {
  // called when the bound element's parent component
  // and all its children are mounted.
  mounted: async (t, { value: o }) => {
    await c(), o && t.focus();
  },
  // called after the parent component and
  // all of its children have updated
  updated: async (t, { value: o, oldValue: i }) => {
    o !== i && o && (await c(), o && t.focus());
  }
};
export {
  s as vFocus
};
